import type { ReactNode } from 'react'
import type { RouteObject } from 'react-router-dom'

/**
 * Wraps routes in a pathless route that only adds an errorElement. A crash in
 * any of them renders `errorElement` where they would have rendered, so the
 * layout above (e.g. the portal's sidebar and top bar) stays on screen.
 *
 * A helper rather than a nested literal so the route lists keep their
 * indentation, and branches that add routes do not conflict with this one.
 */
export const withErrorElement = (errorElement: ReactNode, children: RouteObject[]): RouteObject[] => [
  { errorElement, children },
]
